import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonRounded } from 'is24-corecss';
import { getVeriffVerificationSession } from '../../api/veriff/VeriffVerificationAttempt';
import { useClientConfig } from '../../utils/clientConfigContext';
import { VeriffSessionRequest } from '../../api/veriff/model/VeriffSessionRequest';
import { useTvsState } from '../../utils/useTvsState';
import { useVeriffSession } from '../../utils/veriffSessionContext';
import { ApiResponseError } from '../../api/ApiResponseError';
import { trackEvent } from '../../tracking/tracking';

interface VeriffVerificationProps {
  onContentChange: (content: React.ReactNode) => void;
  onError: (error: string) => void;
}

const VeriffVerification: React.FC<VeriffVerificationProps> = ({ onContentChange, onError }) => {
  const { clientId } = useClientConfig();
  const [, setTvsState] = useTvsState();
  const { setSessionUrl, setSessionId } = useVeriffSession();
  const { t } = useTranslation();
  const [isRequestPending, setIsRequestPending] = useState<boolean>(false);

  React.useEffect(() => {
    onContentChange(
      <div className='grid grid-flex font-body-small-regular font-lightgray desk-margin-top-xxl lap-margin-top-xxl modal-bottom-text palm-margin-bottom-l'>
        {t('VerificationLandingPage.subContent')}
      </div>,
    );
  }, [t, onContentChange]);

  const onVeriffVerificationClick = () => {
    const veriffVerificationTrigger: VeriffSessionRequest = {
      triggeredBy: clientId,
    };
    setIsRequestPending(true);
    getVeriffVerificationSession(veriffVerificationTrigger)
      .then((response) => {
        trackEvent('is24.de.sicherheit.verifizierung.modal', 'verification_started', 'user', clientId, 'veriff');
        setSessionUrl(response.sessionUrl);
        setSessionId(response.sessionId);
        setTvsState('veriff_verification');
      })
      .catch((error: ApiResponseError) => {
        if (error.responseStatus === 401) {
          onError('errors.unauthorized');
        }
        onError('errors.default');
      })
      .finally(() => {
        setIsRequestPending(false);
      });
  };

  return (
    <div className='modal-footer verification-modal-footer'>
      <div className='grid grid-flex'>
        <div className='grid-item one-whole palm-one-whole palm-margin-top-l'>
          <div className='grid-flex grid-justify-end verification-footer-div palm-one-whole'>
            <ButtonRounded
              data-testid='veriff-verification-button'
              className='verification-footer-button'
              loading={isRequestPending}
              onClick={onVeriffVerificationClick}
              label={t('VerificationLandingPage.buttonText')}
              size={'medium'}
            ></ButtonRounded>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VeriffVerification;
